/**
 * Supported scopes for the Airwallex embedded components SDK.
 * Pass the relevant scope(s) to the airwallexAuthorization GraphQL query
 * when requesting an authorizationCode for a specific embedded component.
 *
 * Reference: https://www.airwallex.com/docs/payouts/beneficiaries/embedded-beneficiary-component
 */
export const AIRWALLEX_SCOPES = {
  /** Used by the embedded onboarding component. */
  ONBOARDING_WRITE: 'onboarding:write',
  /** Used by the embedded payout component and the embedded beneficiary component. */
  TRANSFER_WRITE: 'transfer:write',
  /** Used by the embedded KYB component. */
  KYB_WRITE: 'kyb:write',
  /** Used by the embedded RFI component to view open RFIs. */
  RFI_READ: 'rfi:read',
  /** Used by the embedded RFI component to edit and submit responses to RFIs. */
  RFI_WRITE: 'rfi:write',
  /** Used by the embedded SCA component to get the context of SCA. */
  SCA_READ: 'sca:read',
  /** Used by the embedded SCA component to set up or change authentication factors. */
  SCA_WRITE: 'sca:write',
  /** Used by the embedded tax form component to get details of tax forms. */
  TAX_FORM_READ: 'tax_form:read',
  /** Used by the embedded tax form component to create or edit tax forms. */
  TAX_FORM_WRITE: 'tax_form:write',
} as const

export type AirwallexScope =
  (typeof AIRWALLEX_SCOPES)[keyof typeof AIRWALLEX_SCOPES]
